import { useContext, useEffect, useRef } from "react"

import { ObjectList } from "web/components"

import { useViewGroup } from "web/hooks/data"
import { useCurrentTLO } from "web/hooks/context"
import { NavigationContext, NavigationProvider } from "web/contexts"

import routes, { paramsToQueryString } from "web/routes/constants"

import { TrashIcon } from "@heroicons/react/24/outline"

export default function DealAssets({
  rootUrl,
  canRedirectToRootUrl,
  selectedIds,
}) {
  const storedDealAssets = useRef()

  const { userCan, data: deal } = useCurrentTLO()
  const NEW_DEAL_ASSET_PATH = `/deals/${deal.id}/deal_assets/new`

  const refreshDealAssets = () => {
    storedDealAssets.current.refresh()
    deal.refresh()
  }

  useEffect(() => {
    document.addEventListener(
      "event-dispatcher:deal-asset-created",
      refreshDealAssets
    )
    return () =>
      document.removeEventListener(
        "event-dispatcher:deal-asset-created",
        refreshDealAssets
      )
  })

  const { viewGroup: dealViewGroup, viewId: dealViewId } =
    useContext(NavigationContext)

  const viewGroup = useViewGroup({
    parentSubjectType: "deal",
    parentSubjectId: deal.id,
    subjectType: "deal_asset",
  })

  function handleItemClick(dealAsset) {
    window.Turbo.visit(
      routes.deal_asset(dealViewGroup.slug, dealViewId, deal.id, dealAsset.id)
    )
  }

  async function handleAddDealAsset(dealAssets) {
    const turbo_frame = document.querySelector("#modal")
    turbo_frame.src = NEW_DEAL_ASSET_PATH
    turbo_frame.reload()

    storedDealAssets.current = dealAssets
  }

  function handleRemoveDealAssets({ selected }) {
    const queryString = paramsToQueryString({
      "selected_ids[]": selected.map((dealAsset) => dealAsset.id),
    })

    window.Turbo.visit(
      `/deals/${deal.id}/deal_assets/deletions/new?${queryString}`,
      { frame: "modal" }
    )
  }

  const selectedItemActions = []
  if (userCan("update")) {
    selectedItemActions.push({
      label: "Remove",
      icon: TrashIcon,
      action: handleRemoveDealAssets,
    })
  }

  return (
    <div className="-m-2.5 mb-0 flex min-h-0 grow flex-col">
      <NavigationProvider viewGroup={viewGroup} viewId={null}>
        <ObjectList
          subjectType="deal_asset"
          parentSubjectType="deal"
          parentSubjectId={deal.id}
          exportPath={`/deals/${deal.id}/deal_assets`}
          availableViews={["table", "cards", "map", "compare", "overview"]}
          defaultView="table"
          onAdd={userCan("update") ? handleAddDealAsset : undefined}
          enableEdit={userCan("update")}
          onItemClick={handleItemClick}
          selectedItemActions={selectedItemActions}
          rootUrl={rootUrl}
          canRedirectToRootUrl={canRedirectToRootUrl}
          selectedIds={selectedIds}
        />
      </NavigationProvider>
    </div>
  )
}
